export const formatDateTimeToDate = (targetDate: Date) => {
  const month = targetDate.getMonth() + 1 // 月は0から11の範囲で表現されるため
  const day = targetDate.getDate()
  //今日と昨日の場合は「今日」「昨日」に変換
  const today = new Date()
  if (today.getMonth() + 1 === month && today.getDate() === day) {
    return '今日'
  }
  const yesterday = new Date(today.setDate(today.getDate() - 1))
  if (yesterday.getMonth() + 1 === month && yesterday.getDate() === day) {
    return '昨日'
  }
  return `${month}月${day}日`
}
